var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',[_c('canvas',{staticClass:"canvas-h canvas-w",attrs:{"id":"imcNinas5a19A"}})])
}]

export { render, staticRenderFns }